<template>
  <div
    class="chart-errors"
    v-if="hasErrors">
    <div
      class="chart-errors__error"
      :key="key"
      v-for="(value, key) in errors"
      v-html="$options.filters.md(value)" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ChartErrors",
  computed: {
    ...mapGetters("chart", ["hasErrors", "errors"])
  }
}
</script>

<style lang="scss">
@keyframes negative-shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}

.chart-errors {
  padding: $px12;

  background-color: $red-10;

  border-radius: $px4;

  @include font-small;

  &__error {
    animation: negative-shake 1s cubic-bezier(.36, .07, .19, .97) both;
  }
}
</style>
